export default "__VITE_ASSET__DQMzh6Te__"